import React, { Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { Navigate, Routes, Route, useNavigate, useLocation } from 'react-router-dom';

const AuditLogsTab = React.lazy(() => import('./maintenance/AuditLogsTab'));
const UsersTab = React.lazy(() => import('./maintenance/UsersTab'));
const DatabasesTab = React.lazy(() => import('./maintenance/DatabasesTab'));
const SettingsTab = React.lazy(() => import('./maintenance/SettingsTab'));

const MaintenancePage = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  
  // Get tab name from URL
  const currentTab = pathname.split('/').pop() || 'audit';

  const handleChange = (event, newValue) => {
    navigate(`/maintenance/${newValue}`);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={currentTab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="Maintenance Tabs" centered>
            <Tab label="Audit" value="audit" />
            <Tab label="Users" value="users" />
            <Tab label="Databases" value="databases" />
            <Tab label="Settings" value="settings" />
          </TabList>
        </Box>
        
        <Suspense fallback={
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1300,
            }}
          >
            <CircularProgress />
          </Box>
        }>
            <Routes>
                <Route path="audit" element={<AuditLogsTab />} />
                <Route path="users" element={<UsersTab />} />
                <Route path="databases" element={<DatabasesTab />} />
                <Route path="settings" element={<SettingsTab />} />
                <Route path="*" element={<Navigate to="/maintenance/audit" replace />} />
            </Routes>
        </Suspense>
      </TabContext>
    </Box>
  );
};

export default MaintenancePage;
